/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type freeTextFieldComponent_viewer$ref: FragmentReference;
declare export opaque type freeTextFieldComponent_viewer$fragmentType: freeTextFieldComponent_viewer$ref;
export type freeTextFieldComponent_viewer = {|
  +id: string,
  +$refType: freeTextFieldComponent_viewer$ref,
|};
export type freeTextFieldComponent_viewer$data = freeTextFieldComponent_viewer;
export type freeTextFieldComponent_viewer$key = {
  +$data?: freeTextFieldComponent_viewer$data,
  +$fragmentRefs: freeTextFieldComponent_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "freeTextFieldComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '86070892a6dab04d87639c3e6fa3ea10';

module.exports = node;
